import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WheelchairIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12.6 6.0002C12.6 6.66644 12.238 7.24814 11.7 7.55937V9.3H14.4V11.1H11.7V12.8996H14.8816L15.4816 13.7996H15.4818L15.5815 13.9491C15.5815 13.9492 15.5815 13.9493 15.5815 13.9494L17.0496 16.1515L18.1007 15.4508L19.0992 16.9485L16.5504 18.6477L13.9183 14.6996H13.7878H9.89998V7.5594C9.36194 7.24818 8.99995 6.66646 8.99995 6.0002C8.99995 5.00608 9.80584 4.2002 10.8 4.2002C11.7941 4.2002 12.6 5.00608 12.6 6.0002ZM10.2 19.8C11.9402 19.8 13.4881 18.9769 14.4757 17.6987L13.39 16.0702C12.7881 17.2174 11.5855 18 10.2 18C8.21182 18 6.60005 16.3882 6.60005 14.4C6.60005 12.9471 7.46078 11.6952 8.70015 11.1264V9.21103C6.44753 9.86101 4.80005 11.9381 4.80005 14.4C4.80005 17.3823 7.21771 19.8 10.2 19.8Z"
      />
    </SvgIcon>
  );
});
